// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file gitpod/v1/runner.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CheckAuthenticationForHostRequest, CheckAuthenticationForHostResponse, CreateRunnerLogsTokenRequest, CreateRunnerLogsTokenResponse, CreateRunnerPolicyRequest, CreateRunnerPolicyResponse, CreateRunnerRequest, CreateRunnerResponse, CreateRunnerTokenRequest, CreateRunnerTokenResponse, DeleteRunnerPolicyRequest, DeleteRunnerPolicyResponse, DeleteRunnerRequest, DeleteRunnerResponse, GetRunnerRequest, GetRunnerResponse, ListRunnerPoliciesRequest, ListRunnerPoliciesResponse, ListRunnersRequest, ListRunnersResponse, ListSCMOrganizationsRequest, ListSCMOrganizationsResponse, ParseContextURLRequest, ParseContextURLResponse, SearchRepositoriesRequest, SearchRepositoriesResponse, UpdateRunnerPolicyRequest, UpdateRunnerPolicyResponse, UpdateRunnerRequest, UpdateRunnerResponse } from "./runner_pb.js";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service gitpod.v1.RunnerService
 */
export const RunnerService = {
  typeName: "gitpod.v1.RunnerService",
  methods: {
    /**
     * Creates a new runner registration with the server. Registrations are very short-lived and must be renewed every 30 seconds.
     *
     * Use this method to:
     * - Register organization runners
     * - Set up runner configurations
     * - Initialize runner credentials
     * - Configure auto-updates
     *
     * ### Examples
     *
     * - Create cloud runner:
     *
     *   Creates a new runner in AWS EC2.
     *
     *   ```yaml
     *   name: "Production Runner"
     *   provider: RUNNER_PROVIDER_AWS_EC2
     *   spec:
     *     desiredPhase: RUNNER_PHASE_ACTIVE
     *     configuration:
     *       region: "us-west"
     *       releaseChannel: RUNNER_RELEASE_CHANNEL_STABLE
     *       autoUpdate: true
     *   ```
     *
     * - Create local runner:
     *
     *   Creates a new local runner on Linux.
     *
     *   ```yaml
     *   name: "Local Development Runner"
     *   provider: RUNNER_PROVIDER_LINUX_HOST
     *   spec:
     *     desiredPhase: RUNNER_PHASE_ACTIVE
     *     configuration:
     *       releaseChannel: RUNNER_RELEASE_CHANNEL_LATEST
     *       autoUpdate: true
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerService.CreateRunner
     */
    createRunner: {
      name: "CreateRunner",
      I: CreateRunnerRequest,
      O: CreateRunnerResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets details about a specific runner.
     *
     * Use this method to:
     * - Check runner status
     * - View runner configuration
     * - Monitor runner health
     * - Verify runner capabilities
     *
     * ### Examples
     *
     * - Get runner details:
     *
     *   Retrieves information about a specific runner.
     *
     *   ```yaml
     *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerService.GetRunner
     */
    getRunner: {
      name: "GetRunner",
      I: GetRunnerRequest,
      O: GetRunnerResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Lists all registered runners with optional filtering.
     *
     * Use this method to:
     * - View all available runners
     * - Filter by runner type
     * - Monitor runner status
     * - Check runner availability
     *
     * ### Examples
     *
     * - List all runners:
     *
     *   Shows all runners with pagination.
     *
     *   ```yaml
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * - Filter by provider:
     *
     *   Lists only AWS EC2 runners.
     *
     *   ```yaml
     *   filter:
     *     providers: ["RUNNER_PROVIDER_AWS_EC2"]
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerService.ListRunners
     */
    listRunners: {
      name: "ListRunners",
      I: ListRunnersRequest,
      O: ListRunnersResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Updates a runner's configuration.
     *
     * Use this method to:
     * - Modify runner settings
     * - Update release channels
     * - Change runner status
     * - Configure auto-update settings
     *
     * ### Examples
     *
     * - Update configuration:
     *
     *   Changes runner settings.
     *
     *   ```yaml
     *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   name: "Updated Runner Name"
     *   spec:
     *     configuration:
     *       releaseChannel: RUNNER_RELEASE_CHANNEL_LATEST
     *       autoUpdate: true
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerService.UpdateRunner
     */
    updateRunner: {
      name: "UpdateRunner",
      I: UpdateRunnerRequest,
      O: UpdateRunnerResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Deletes a runner permanently.
     *
     * Use this method to:
     * - Remove unused runners
     * - Clean up runner registrations
     * - Delete obsolete runners
     *
     * ### Examples
     *
     * - Delete runner:
     *
     *   Permanently removes a runner.
     *
     *   ```yaml
     *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerService.DeleteRunner
     */
    deleteRunner: {
      name: "DeleteRunner",
      I: DeleteRunnerRequest,
      O: DeleteRunnerResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Creates a new authentication token for a runner.
     *
     * Use this method to:
     * - Generate runner credentials
     * - Renew expired tokens
     * - Set up runner authentication
     *
     * Note: This does not expire previously issued tokens.
     *
     * ### Examples
     *
     * - Create token:
     *
     *   Creates a new token for runner authentication.
     *
     *   ```yaml
     *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerService.CreateRunnerToken
     */
    createRunnerToken: {
      name: "CreateRunnerToken",
      I: CreateRunnerTokenRequest,
      O: CreateRunnerTokenResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Creates an access token for runner logs and debug information.
     *
     * Generated tokens are valid for one hour and provide runner-specific access permissions.
     * The token is scoped to a specific runner and can be used to access support bundles.
     *
     * ### Examples
     *
     * - Generate runner logs token:
     *
     *   ```yaml
     *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerService.CreateRunnerLogsToken
     */
    createRunnerLogsToken: {
      name: "CreateRunnerLogsToken",
      I: CreateRunnerLogsTokenRequest,
      O: CreateRunnerLogsTokenResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Parses a context URL and returns the parsed result.
     *
     * Use this method to:
     * - Validate context URLs
     * - Check repository access
     * - Verify branch existence
     *
     * Returns:
     * - FAILED_PRECONDITION if authentication is required
     * - PERMISSION_DENIED if access is not allowed
     * - INVALID_ARGUMENT if URL is invalid
     * - NOT_FOUND if repository/branch doesn't exist
     *
     * ### Examples
     *
     * - Parse URL:
     *
     *   Parses and validates a context URL.
     *
     *   ```yaml
     *   contextUrl: "https://github.com/org/repo/tree/main"
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerService.ParseContextURL
     */
    parseContextURL: {
      name: "ParseContextURL",
      I: ParseContextURLRequest,
      O: ParseContextURLResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Searches for repositories across all authenticated SCM hosts.
     *
     * Use this method to:
     * - List available repositories
     * - Search repositories by name or content
     * - Discover repositories for environment creation
     *
     * Returns repositories from all authenticated SCM hosts in natural sort order.
     * If no repositories are found, returns an empty list.
     *
     * ### Examples
     *
     * - List all repositories:
     *
     *   Returns up to 25 repositories from all authenticated hosts.
     *
     *   ```yaml
     *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * - Search repositories:
     *
     *   Searches for repositories matching the query across all hosts.
     *
     *   ```yaml
     *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   searchString: "my-project"
     *   limit: 10
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerService.SearchRepositories
     */
    searchRepositories: {
      name: "SearchRepositories",
      I: SearchRepositoriesRequest,
      O: SearchRepositoriesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Lists SCM organizations the user belongs to.
     *
     * Use this method to:
     * - Get all organizations for a user on a specific SCM host
     * - Check organization admin permissions for webhook creation
     *
     * ### Examples
     *
     * - List GitHub organizations:
     *
     *   Lists all organizations the user belongs to on GitHub.
     *
     *   ```yaml
     *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   scmHost: "github.com"
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerService.ListSCMOrganizations
     */
    listSCMOrganizations: {
      name: "ListSCMOrganizations",
      I: ListSCMOrganizationsRequest,
      O: ListSCMOrganizationsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Checks if a user is authenticated for a specific host.
     *
     * Use this method to:
     * - Verify authentication status
     * - Get authentication URLs
     * - Check PAT support
     *
     * ### Examples
     *
     * - Check authentication:
     *
     *   Verifies authentication for a host.
     *
     *   ```yaml
     *   host: "github.com"
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerService.CheckAuthenticationForHost
     */
    checkAuthenticationForHost: {
      name: "CheckAuthenticationForHost",
      I: CheckAuthenticationForHostRequest,
      O: CheckAuthenticationForHostResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Lists policies for a runner.
     *
     * Use this method to:
     * - View access controls
     * - Check policy configurations
     * - Audit permissions
     *
     * ### Examples
     *
     * - List policies:
     *
     *   Shows all policies for a runner.
     *
     *   ```yaml
     *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerService.ListRunnerPolicies
     */
    listRunnerPolicies: {
      name: "ListRunnerPolicies",
      I: ListRunnerPoliciesRequest,
      O: ListRunnerPoliciesResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Creates a new policy for a runner.
     *
     * Use this method to:
     * - Set up access controls
     * - Define group permissions
     * - Configure role-based access
     *
     * ### Examples
     *
     * - Create admin policy:
     *
     *   Grants admin access to a group.
     *
     *   ```yaml
     *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   groupId: "f53d2330-3795-4c5d-a1f3-453121af9c60"
     *   role: RUNNER_ROLE_ADMIN
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerService.CreateRunnerPolicy
     */
    createRunnerPolicy: {
      name: "CreateRunnerPolicy",
      I: CreateRunnerPolicyRequest,
      O: CreateRunnerPolicyResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Updates an existing runner policy.
     *
     * Use this method to:
     * - Modify access levels
     * - Change group roles
     * - Update permissions
     *
     * ### Examples
     *
     * - Update policy role:
     *
     *   Changes a group's access level.
     *
     *   ```yaml
     *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   groupId: "f53d2330-3795-4c5d-a1f3-453121af9c60"
     *   role: RUNNER_ROLE_USER
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerService.UpdateRunnerPolicy
     */
    updateRunnerPolicy: {
      name: "UpdateRunnerPolicy",
      I: UpdateRunnerPolicyRequest,
      O: UpdateRunnerPolicyResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Deletes a runner policy.
     *
     * Use this method to:
     * - Remove access controls
     * - Revoke permissions
     * - Clean up policies
     *
     * ### Examples
     *
     * - Delete policy:
     *
     *   Removes a group's access policy.
     *
     *   ```yaml
     *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   groupId: "f53d2330-3795-4c5d-a1f3-453121af9c60"
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerService.DeleteRunnerPolicy
     */
    deleteRunnerPolicy: {
      name: "DeleteRunnerPolicy",
      I: DeleteRunnerPolicyRequest,
      O: DeleteRunnerPolicyResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

